import { render, staticRenderFns } from "./ECNHalfYear2024.vue?vue&type=template&id=f0c846be&scoped=true"
import script from "./ECNHalfYear2024.vue?vue&type=script&lang=js"
export * from "./ECNHalfYear2024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c846be",
  null
  
)

export default component.exports